<div class="video-container">
  <div id="kaltura_player_{{ streamKey }}" class="embed-responsive embed-responsive-16by9" [ngStyle]="style"></div>
</div>
